"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppNameById = void 0;
const AppId_1 = require("../enums/AppId");
const getAppNameById = (appId) => Object.keys(AppId_1.AppId).find((key) => AppId_1.AppId[key] === appId);
exports.getAppNameById = getAppNameById;
//# sourceMappingURL=getAppNameById.js.map